import {getBottomSpace, isIphoneX} from 'react-native-iphone-screen-helper';
import Modal from 'react-native-modal';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {Dimensions, Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {ScrollView} from 'react-native-gesture-handler';
import {css} from 'styled-components/native';

//@ts-ignore
export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;
export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  right: 16px;
  top: 0px;
  z-index: 301;
`;
export const CloseButtonIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  color: ${({theme}) => theme.colors.title};
  align-items: center;
  justify-content: center;
`;

export const ContainerImage =
  Platform.OS === 'web'
    ? styled.View`
        position: absolute; /* habilita o z-index no web */
        left: 0;
        right: 0;

        bottom: calc(60% - ${RFValue(30)}px);
        z-index: 3;
        pointer-events: none;
      `
    : styled.View`
        z-index: 1;
      `;

const imageDimensions = isIphoneX()
  ? Dimensions.get('window').width >= 393 &&
    Dimensions.get('window').width < 431
    ? RFValue(140)
    : RFValue(158)
  : RFValue(150);

//@ts-ignore
export const VehicleBanner =
  Platform.OS === 'web'
    ? styled(FastImage)`
        width: 100%;
        height: ${imageDimensions}px;
      `
    : styled(FastImage)`
        width: 100%;
        height: ${imageDimensions}px;
        position: absolute;
        bottom: -${RFValue(30)}px;
        z-index: 2;
      `;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.alert};
  height: 60%;
  width: 100%;
  justify-content: center;
  overflow: hidden;
  position: relative; /* cria contexto de empilhamento confiável */
  ${Platform.OS === 'web' ? '  z-index: 2;' : ''}
`;

export const ModalInfos = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  z-index: 201;
`;
export const ModalSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  z-index: 201;
`;

export const ModalBody = styled.View`
  padding: 0 24px;
  flex: 1;
  margin-top: ${RFValue(45)}px;
  position: relative;
`;

export const LoadingContainer = styled.View`
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-top: -${RFValue(50)}px;
`;

export const ModalList = styled.ScrollView``;

export const PromotionContainer = styled.View``;

export const PromotionBanner = styled.View<{selected: boolean}>`
  padding: ${RFValue(8)}px ${RFValue(8)}px;
  background-color: ${({theme, selected}) =>
    selected ? theme.colors.background : theme.colors.background};
  border-radius: ${RFValue(8)}px;
  align-items: center;
  flex-direction: row;
  align-items: center;
  border-width: 1px;
  margin-bottom: ${RFValue(10)}px;
  border-color: ${({theme, selected}) =>
    selected ? theme.colors.banner_green : 'transparent'};
`;
export const PromotionIconContainer = styled.Pressable`
  align-items: center;
  justify-content: center;
`;
export const PromotionIconCircle = styled.View`
  background-color: ${({theme}) => theme.colors.promotion_value_bg};
  width: ${RFValue(36)}px;
  height: ${RFValue(36)}px;
  border-radius: ${RFValue(24)}px;
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(12)}px;
`;
export const PromotionBody = styled.View`
  flex-direction: column;
  flex: 1;
`;
//@ts-ignore
export const PromotionValuesContainer = styled(ScrollView)`
  margin-right: -${RFValue(8)}px;
  margin-top: ${RFValue(6)}px;
`;
export const PromotionValuesBlock = styled.Pressable`
  flex-direction: column;

  padding: ${RFValue(2)}px ${RFValue(6)}px;
  background-color: ${({theme}) => theme.colors.promotion_value_bg};
  margin-right: ${RFValue(5)}px;
  border-radius: ${RFValue(8)}px;
  border: 1px solid ${({theme}) => theme.colors.promotion_value_bg};
`;

export const PromotionIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(20)}px;
`;
export const PromotionText = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(9)}px;
  text-transform: uppercase;
  align-items: center;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const PromotionCouponText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;
export const PromotionCoupon = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const PromotionProduct = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const ModalFooter = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? getBottomSpace()
    : RFValue(20)}px;
`;

export const PromotionRow = styled.Pressable`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const PromotionInfoContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const PromotionInfo = styled.View``;

export const PromotionRadio = styled.View<{selected: boolean}>`
  border-radius: 12px;
  border-width: 6px;
  width: 24px;
  height: 24px;
  ${({selected}) =>
    selected
      ? css`
          border-color: ${({theme}) => theme.colors.banner_green};
        `
      : css`
          border-color: ${({theme}) => theme.colors.border_light};
          background-color: ${({theme}) => theme.colors.border_light};
        `}
`;

export const PromotionIconCheck = styled(Feather)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(10)}px;
  margin-left: ${RFValue(1)}px;
`;

export const ErrorContainer = styled.View`
  justify-content: center;
  align-items: center;
  margin-top: ${RFPercentage(13)}px;
`;
export const ErrorText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  z-index: 201;
  text-align: center;
  max-width: 50%;
`;
